import {useMutation, useQueryClient} from "@tanstack/react-query";
import {withdrawalPagoMovilService} from "../../services/wallet/withdrawal.service";

const useWithdrawalPagoMovil = () => {
  const query = useQueryClient();
  const {mutate, isSuccess, isError, error, isPending} = useMutation({
    mutationFn: withdrawalPagoMovilService,
    onSuccess: _data => {
      query.invalidateQueries(["userWallet"]);
    },
    onError: _error => {},
  });

  return {
    requestWithdrawal: mutate,
    isSuccess,
    isError,
    error,
    isPending,
  };
};

export default useWithdrawalPagoMovil;
